import { EventBus } from "../../../eventbus";
import { baseUrl } from "../../../config.js";
import { Promise } from "es6-promise";

export default {
  props: {
    items: [Object, Array],
    type: String,
  },

  data() {
    return {
      target: 0,
      object: {},
      company: this.$store.state.company,
      parent: null,
      isLoading: false,
    };
  },
  created() {
    this.setup();
  },
  computed: {
    addS() {
      return Array.isArray(this.items) && this.items.length > 1 ? "s" : "";
    },
  },
  methods: {
    setup() {
      const files = [];
      const folders = [];

      if (Array.isArray(this.items)) {
        //is array
        const files = [];
        const folders = [];

        this.items.forEach((item) => {
          if (item.extension) {
            //is file
            files.push(item.id);
          } else {
            //is folder
            folders.push(item.id);
          }
        });

        this.object.name = true;

        this.target = {
          files: files,
          folders: folders,
        };
      } else if (this.items.collectionId) {
        if (this.type === "collection") {
          this.$axios
            .get(`${baseUrl}/collection/${this.items.collectionId}`, {
              responseType: "json",
            })
            .then((r) => {
              this.object = { name: r.data.collectionData.name };
            });

          this.target = this.items.collectionId;
        } else {
          this.parent = this.items.collectionId;
          this.object.name = true;

          this.target = this.$store.state.transferItems.selectedFiles.map(
            (file) => file.id
          );
        }
      } else {
        //is one item
        if (this.items.extension) {
          //is file
          files.push(this.items.id);
        } else {
          //is folder
          folders.push(this.items.id);
        }

        this.mySpace = this.items.myspace;

        this.object = this.items;

        this.target = {
          files: files,
          folders: folders,
        };
      }
    },
    extensionName(string) {
      if (typeof string === "string") {
        return string.replace(".", "");
      }
    },
    remove() {
      let formData = new FormData();

      this.isLoading = true;

      if (this.type == "collection") {
        formData.append("collection", this.target);

        this.$axios.post(baseUrl + "/collectiondelete", formData).then(() => {
          this.isLoading = false;

          //return to collections overview
          this.$router.push(`/${this.$store.state.company}/collections`);

          this.$store.state.transferItems = {
            selectedFiles: [],
            selectedFolders: [],
            collection: {},
          };

          //this.$root.$refs.navigation_sidebar.showCollectedBadge();
        });
      }

      if (this.type == "collectionfiles") {
        if (this.forDownload == 1) {
          let collectedItems = localStorage.getItem(
            this.$store.state.company + "_collect_for_download"
          );
          if (collectedItems) {
            let splicers = [];
            collectedItems = JSON.parse(collectedItems);
            this.target = JSON.parse(this.target);
            let toDelete = collectedItems.find((o, i) => {
              if (this.target.includes(o.id)) {
                splicers.push(i);
                //return true; // DON'T stop searching
              }
            });
            for (let i = splicers.length - 1; i >= 0; i--) {
              collectedItems.splice(splicers[i], 1);
            }
          } else {
            collectedItems = [];
          }
          localStorage.setItem(
            this.$store.state.company + "_collect_for_download",
            JSON.stringify(collectedItems)
          );
          EventBus.$emit("refreshcollection");
          this.isLoading = false;
        } else {
          formData.append("files", JSON.stringify([...this.target]));
          formData.append("collection", this.parent);

          this.$axios
            .post(baseUrl + "/collectiondeletefiles", formData)
            .then((response) => {
              EventBus.$emit(`collection-detail-update`);

              this.isLoading = false;

              this.$store.state.transferItems = {
                selectedFiles: [],
                selectedFolders: [],
                collection: {},
              };

              EventBus.$emit("closeallactions");

              //this.$root.$refs.navigation_sidebar.showCollectedBadge();
            })
            .catch((e) => {
              this.$store.state.transferItems = {
                selectedFiles: [],
                selectedFolders: [],
                collection: {},
              };
            });
        }

        //this.$root.$refs.navigation_sidebar.showCollectedBadge();
      }

      if (this.type == "multiple") {
        formData.append("folders", this.target.folders);
        formData.append("files", this.target.files);
        formData.append("myspace", this.mySpace);

        this.$axios.post(baseUrl + "/deletemultiple", formData).then((r) => {
          this.isLoading = false;
          EventBus.$emit("closeallactions");
          //refresh folders
          EventBus.$emit(`desktop-files-update`);
          EventBus.$emit(`tree-overview-reset`);

          // this.$root.$refs.navigation_sidebar.showCollectedBadge();
          this.$store.state.transferItems = {
            selectedFiles: [],
            selectedFolders: [],
            collection: {},
          };
        });
      }

      if (this.type === "removeFilesPermanently") {
        const promises = [];

        formData.append("folder", this.target.folders);
        formData.append("file", this.target.files);

        promises.push(this.$axios.post(baseUrl + "/fileForceDelete", formData));
        promises.push(
          this.$axios.post(baseUrl + "/folderForceDelete", formData)
        );

        Promise.all(promises).then((r) => {
          this.isLoading = false;
          EventBus.$emit("closeallactions");
          //refresh folders
          EventBus.$emit(`desktop-files-update`);
          EventBus.$emit(`tree-overview-reset`);

          // this.$root.$refs.navigation_sidebar.showCollectedBadge();
          this.$store.state.transferItems = {
            selectedFiles: [],
            selectedFolders: [],
            collection: {},
          };
        });

        /*.then((r) => {
          this.isLoading = false;
          EventBus.$emit("closeallactions");
          //refresh folders
          EventBus.$emit(`desktop-files-update`);
          EventBus.$emit(`tree-overview-reset`);

          // this.$root.$refs.navigation_sidebar.showCollectedBadge();
          this.$store.state.transferItems = {
            selectedFiles: [],
            selectedFolders: [],
            collection: {},
          };
        });*/
      }

      if (this.type === "emptyBin") {
        this.$axios.post(baseUrl + "/emptyTrash", formData).then((r) => {
          this.isLoading = false;
          EventBus.$emit("closeallactions");
          //refresh folders
          EventBus.$emit(`desktop-files-update`);
          EventBus.$emit(`tree-overview-reset`);

          // this.$root.$refs.navigation_sidebar.showCollectedBadge();
          this.$store.state.transferItems = {
            selectedFiles: [],
            selectedFolders: [],
            collection: {},
          };
        });
      }
    },
  },
};
